
export default {
  name: "public",
  head() {
    return {
      title: "Inicio ",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Llegofactura.com es un portal de recepción y flujo de documentos electrónicos diseñado para dotar las empresas con una herramienta tecnológica que reduzca el tiempo que se emplea en la ejecución de procesos de tesorería, ayudando a la organización y coordinación de diferentes áreas, útil al seguimiento del proceso de pago y automatización de su registro en los sistemas de tesorería, contabilidad e inventarios.",
        },
      ],
    };
  },
  beforeMount() {
    this.$axios.setHeader("Cache-Control", "no-cache");
    this.year = this.$moment().format("YYYY");
  },
  data() {
    return {
      year: null,
    };
  },
};
